import { Breakpoints } from '@angular/cdk/layout';

export class BreakpointHelpers {
  static displayNameMap = new Map([
    [Breakpoints.XSmall, 'XSmall'],
    [Breakpoints.Small, 'Small'],
    [Breakpoints.Medium, 'Medium'],
    [Breakpoints.Large, 'Large'],
    [Breakpoints.XLarge, 'XLarge'],
  ]);

  static breakpointList = [
    Breakpoints.XSmall,
    Breakpoints.Small,
    Breakpoints.Medium,
    Breakpoints.Large,
    Breakpoints.XLarge,
  ];
  static landscapeList = [
    Breakpoints.HandsetLandscape,
    Breakpoints.TabletLandscape,
  ];
}
